/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/10/21
 */

import { ReactComponent as EyeIcon } from '../material/eye.svg';
import { ReactComponent as MoreVerticalIcon } from '../material/more_vert.svg';

export default {
    EyeIcon,
    MoreVerticalIcon,
};
